import { Flex, Typography } from '@banhala/ui-kit';

interface EditToggleButtonProps {
  children: string;
  disabled?: boolean;
  onPress?: () => void;
}

export const EditToggleButton = ({
  children,
  disabled,
  onPress,
}: EditToggleButtonProps) => (
  <Flex
    padding={{ horizontal: 12, vertical: 10 }}
    onPress={disabled ? undefined : onPress}
  >
    <Typography
      type={'subtitle1'}
      color={disabled ? 'content_disabled' : 'content_blue_primary'}
    >
      {children}
    </Typography>
  </Flex>
);
